import { useJsApiLoader } from '@react-google-maps/api';
import React from 'react';

const libraries = ['drawing', 'geometry', 'places']; // Important : ne pas recréer cette constante à chaque render

export default function MapsProvider({ children }) {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries
  });

  if (loadError) return <div>Erreur de chargement de Google Maps</div>;
  if (!isLoaded) return <div>Chargement de Google Maps...</div>;

  return <>{children}</>;
}
